var verbose     = true;

jQuery(function($){

	ValidateAddress(".acf-form", "#acf-field_57b180e9ef4bf","#acf-field_57b180fdef4c0");
	// ---------------------------------------------------
	// 2018-11-05: disable check on shopping cart
	// ---------------------------------------------------
	// ValidateAddress(".woocommerce-checkout", "#billing_address_2","#billing_postcode");
	// ValidateAddress(".woocommerce-checkout", "#shipping_address_2","#shipping_postcode");
	// ---------------------------------------------------
});

function ValidateAddress(formCssClass, housenrfieldId, postcodeFieldId) {

	// init form fields
	var $gsaform    = jQuery(formCssClass);
	var $housenr    = jQuery(housenrfieldId);
	var $postcode   = jQuery(postcodeFieldId);

	$housenr.blur(function(){
		if (verbose) { console.log('Housenr. blur event...'); }
		addressCheck($housenr.val(), $postcode.val());
	});

	$postcode.blur(function(){
		if (verbose) { console.log('Postcode blur event...'); }
		addressCheck($housenr.val(), $postcode.val());
	});

	$gsaform.submit(function(){
		if (verbose) { console.log('GSA form submit event...'); }
		addressCheck($housenr.val(), $postcode.val());
	});

}

function addressCheck(housenrVal, postcodeVal) {

	if (verbose) { console.log('housenrVal = ' + housenrVal); }
	if (verbose) { console.log('postcodeVal = ' + postcodeVal); }

    if(housenrVal != '' && postcodeVal != '') {
        if (verbose) { console.log('Housenr. EN postcode gevuld'); }

        $url = './?control=organisation_addresscheck&housenr=' + housenrVal + '&postcode=' + postcodeVal;

        // make the AJAX call
        jQuery.get( $url, function( response ) {

        	if (verbose) { console.dir(response); }
        	if (response != 'FAIL') {
		  		alert('Er is al een GSA op dit adres geregistreerd, namelijk: ' + response);
        	}

		});
 	}
}
